import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-inbuilt-filter',
  standalone: false,
  templateUrl: './inbuilt-filter.component.html',
  styleUrl: './inbuilt-filter.component.scss'
})
export class InbuiltFilterComponent {
  @Input() disabled = false;
  @Output() addFilter = new EventEmitter<void>();
}
